export const SERVER_URL = (window.location.host === 'rooseveltcollier.com' || window.location.host === 'www.rooseveltcollier.com' )
  ? 'https://rvc.internetcompany.io'
  : 'http://127.0.0.1:19362';



// WEBPACK FOOTER //
// ./src/data/config.js